import { Outlet, useLocation } from "react-router";
import { AclTypes } from "../../../../Core/Api/Types/acl-types";
import DashboardLayout from "../../../../Layouts/Dashboard/dashboard";
import { routePaths } from "../../../../Router/router";
import { UserHasAcl, UserHasAcls } from "../../../../Utils/helpers";
import { useContext, useState } from "react";
import IngestBanner from "../../../../Components/Banners/IngestBanner";
import SelectModeSubbarOpener from "../../../../Components/Banners/SelectModeBanner/opener";
import { Typography } from "@mui/material";
import { TutorialContext } from "../../../../Utils/Helpers/tutorial";
import HelpPopup from "../../../../Components/HelpPopup";
import IngestPacksBanner from "../../../../Components/Banners/IngestPacks";
import { cacheService } from "../../../../Core/Api/services";
import { PlatformMode } from "../../../../Core/Api/Types/platform-mode";
import { useTranslation } from "react-i18next";

function Ingest() {
  const { t } = useTranslation();
  const [selectedItemIds, setSelectedItems] = useState<number[]>([]);
  const [reload, setReload] = useState<number>(0);

  const handleCloseClick = () => {
    setSelectedItems([]);
  };

  const location = useLocation();

  const curPath = location.pathname.toString();
  // Use no max width for order items due to large data amount
  let finalMaxWidth =
    curPath === routePaths.ingest.path ||
    curPath === routePaths.ingestRequested.path ||
    curPath === routePaths.ingestRejected.path ||
    curPath === routePaths.ingestAdamSources.path ||
    curPath === routePaths.ingestAdamTrailers.path
      ? false
      : undefined;

  const enableIngestRequestInternalMetadataTag =
    curPath === routePaths.ingestRequested.path && UserHasAcl(AclTypes.aclSuperUser);
  const enableIngestRequestDelete = curPath === routePaths.ingestRequested.path;

  const tutorialContext = useContext(TutorialContext);
  const { setTutorialPage } = { ...tutorialContext };
  const [helpPopupAnchorEl, setHelpPopupAnchorEl] = useState<HTMLElement | null>(null);
  const [showTuto, setShowTuto] = useState<boolean>(true);

  /* useEffect(() => {
    let show = cacheService.GetUserInfo().startup?.tutorials?.includes(StartupHelpTutorialType.Ingest) as boolean;
    setShowTuto(show);
  }, [helpPopupAnchorEl]);*/

  const pathPacks = location.pathname.includes(routePaths.ingestPacksSingle.path);

  const handleHelpClick: React.MouseEventHandler<HTMLElement> = (e) => {
    if (!setTutorialPage) return;

    setTutorialPage("ingest");
    e.stopPropagation();
    setHelpPopupAnchorEl(e.currentTarget);
  };

  const onClosePopup = () => {
    setHelpPopupAnchorEl(null);
  };

  const processingPaths =
    cacheService.GetPlatformMode() === PlatformMode.Adam
      ? [
          {
            to: routePaths.ingestAdamSources.path,
            hide: !UserHasAcls([AclTypes.aclIngestMonitor]),
            label: <Typography id="tutorial-ingest-processing">{t("route:linkTitle.sources")}</Typography>,
          },
          {
            to: routePaths.ingestAdamTrailers.path,
            hide: !UserHasAcls([AclTypes.aclIngestMonitor]),
            label: <Typography id="tutorial-ingest-processing">{t("route:linkTitle.trailers")}</Typography>,
          },
        ]
      : [
          {
            to: routePaths.ingest.path,
            hide: !UserHasAcls([AclTypes.aclIngestMonitor]),
            label: <Typography id="tutorial-ingest-processing">{t("common:processing")}</Typography>,
          },
        ];

  return (
    <DashboardLayout
      sxContent={{ paddingX: 2 }}
      Banner={
        !pathPacks ? (
          <IngestBanner
            items={selectedItemIds}
            handleCloseClick={handleCloseClick}
            enableIntMetadataTagging={enableIngestRequestInternalMetadataTag}
            enableDelete={enableIngestRequestDelete}
          />
        ) : (
          <IngestPacksBanner
            items={selectedItemIds}
            handleCloseClick={handleCloseClick}
            onMoveOk={() => setReload((prev) => prev + 1)}
          />
        )
      }
    >
      <Outlet context={{ selectedItemIds: selectedItemIds, setSelectedItems: setSelectedItems, reload: reload }} />
      <SelectModeSubbarOpener selectedObjects={selectedItemIds} />

      {helpPopupAnchorEl && (
        <HelpPopup visible={Boolean(helpPopupAnchorEl)} onClose={onClosePopup} anchorEl={helpPopupAnchorEl} />
      )}
    </DashboardLayout>
  );
}

export default Ingest;
